var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 514,
    viewBox: "0 0 347 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.311 258.915H315.44V296.695H327.311V258.915Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.894 248.129H337.023V296.708H348.894V248.129Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3252 239.587C29.5052 239.023 29.6972 238.447 29.8891 237.883",
    stroke: "#979797",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0752 234.512C52.2742 177.331 121.219 117.679 201.555 176.504C260.511 219.683 325.405 174.055 325.405 110.88",
    stroke: "#979797",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeDasharray: "2.56 2.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.224 94.9197H309.946V110.205H337.224V94.9197Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.946 94.9196L323.591 85.0935L337.224 94.9196H309.946Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.224 94.9197L323.591 104.746L309.946 94.9197H337.224Z",
    fill: "#DDDCE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.591 102.562L312.98 94.9197H309.946L323.591 104.746L337.224 94.9197H334.191L323.591 102.562Z",
    fill: "#CECDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.165 484.723H30.8364C27.8988 484.723 25.5127 482.335 25.5127 479.396V301.039C25.5127 298.099 27.8988 295.712 30.8364 295.712H320.165C323.102 295.712 325.488 298.099 325.488 301.039V479.396C325.488 482.335 323.102 484.723 320.165 484.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.992 498.316H4.98487C2.04722 498.316 -0.338867 495.928 -0.338867 492.989V490.793C-0.338867 487.854 2.04722 485.467 4.98487 485.467H345.992C348.929 485.467 351.315 487.854 351.315 490.793V492.989C351.315 495.928 348.941 498.316 345.992 498.316Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.107 304.206H35.8805C33.9817 304.206 32.4424 305.745 32.4424 307.644V472.79C32.4424 474.689 33.9817 476.228 35.8805 476.228H315.107C317.006 476.228 318.545 474.689 318.545 472.79V307.644C318.545 305.745 317.006 304.206 315.107 304.206Z",
    fill: "#E8F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.94 324.59H63.5872C59.7895 324.59 56.7109 327.669 56.7109 331.466V446.664C56.7109 450.462 59.7895 453.541 63.5872 453.541H287.94C291.738 453.541 294.816 450.462 294.816 446.664V331.466C294.816 327.669 291.738 324.59 287.94 324.59Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.481 288.573C205.086 295.844 204.126 296.36 204.462 298.903C204.798 301.447 202.256 312.965 198.203 316.516C194.138 320.067 186.524 319.395 181.788 313.3C177.052 307.206 176.369 302.599 176.033 301.507C175.697 300.427 177.724 279.083 191.776 279.755C205.829 280.439 205.673 285.07 205.481 288.573Z",
    fill: "#F8CDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.688 298.819C177.305 291.021 171.801 295.34 170.446 289.761C169.091 284.17 168.24 269.101 176.873 270.793C185.506 272.484 179.247 288.921 179.919 292.304C180.602 295.688 177.796 300.859 177.688 298.819Z",
    fill: "#1A2448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.679 279.743C177.665 264.674 190.255 262.646 200.746 264.17C211.238 265.694 216.61 272.329 214.631 277.895C213.456 281.183 209.427 289.581 205.531 290.601C205.531 290.601 206.166 283.822 196.178 281.963C186.19 280.103 181.718 285.922 180.171 288.993C178.612 292.065 174.08 282.79 174.679 279.743Z",
    fill: "#1A2448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.577 303.582C176.383 301.147 174.428 299.923 173.829 296.768C173.229 293.6 173.289 291.993 175.771 293.084C177.21 293.72 179.44 295.784 179.189 298.003C178.949 300.247 178.577 303.582 178.577 303.582Z",
    fill: "#F8CDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.794 327.53V317.98C191.574 319.671 185.71 318.34 181.789 313.301C178.576 309.162 177.233 305.718 176.586 303.583V327.53C176.586 329.989 167.581 330.973 168.924 334.105C170.267 337.236 178.48 338.22 186.19 338.22C193.9 338.22 202.113 337.236 203.456 334.105C204.787 330.973 195.794 329.989 195.794 327.53Z",
    fill: "#E1B8A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.924 344.614C221.646 337.116 201.202 330.949 201.202 330.949C201.202 330.949 197.797 338.208 187.341 338.208C176.885 338.208 171.514 330.949 171.514 330.949C158.24 333.409 144.847 342.911 141.214 347.974C137.905 352.605 123.624 381.063 120.555 388.022C116.945 396.192 113.672 406.522 113.672 406.522C113.672 406.522 110.555 418.832 117.749 423.139C118.516 423.595 119.391 423.931 120.327 424.195C118.624 417.908 122.161 411.525 127.869 408.754C131.586 406.942 134.655 405.706 137.005 404.878C136.058 403.295 138.336 400.451 138.336 400.451L149.559 382.599C149.559 382.599 151.849 410.961 152.185 418.496C152.521 426.03 152.809 453.541 152.809 453.541H200.423H228.72L230.602 382.059C230.602 382.059 248.264 401.471 251.897 404.422C255.53 407.374 258.72 408.742 258.72 408.742C258.72 408.742 258.54 402.695 262.809 396.468C264.175 394.464 269.175 392.245 269.175 392.245C269.175 392.245 236.19 352.125 228.924 344.614Z",
    fill: "#4293EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M230.578 382.059C230.698 373.373 226.981 365.766 230.578 369.245C234.175 372.725 235.914 384.47 241.789 387.074C247.653 389.677 248.96 390.769 250.914 395.34C252.581 399.227 254.715 402.323 259.055 405.37C258.66 407.422 258.696 408.754 258.696 408.754C258.696 408.754 255.518 407.386 251.873 404.434C248.24 401.471 230.578 382.059 230.578 382.059Z",
    fill: "#16399D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.484 396.937C266.897 401.16 264.487 405.395 264.787 409.618C265.086 413.842 270.674 419.132 272.484 418.533C274.295 417.933 308.264 392.858 313.396 389.378C318.527 385.899 318.228 384.243 322.005 384.243C325.782 384.243 331.513 384.399 333.479 384.243C335.446 384.087 344.655 373.673 344.199 372.618C343.743 371.562 334.535 378.964 333.024 378.964C331.513 378.964 325.17 377.153 322.304 377.153C319.439 377.153 315.662 379.876 313.695 381.532C311.729 383.188 288.635 394.069 282.149 396.781C275.65 399.504 272.484 396.937 272.484 396.937Z",
    fill: "#E3AA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.6 378.988C319.967 376.6 321.393 374.896 322.952 374.489C324.523 374.081 330.17 372.329 331.19 372.521C332.209 372.713 328.468 374.968 326.837 375.436C325.206 375.916 324.595 378.028 324.595 378.028L318.6 378.988Z",
    fill: "#E3AA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.152 392.245L272.486 396.936C272.486 396.936 268.481 401.423 268.265 406.474C267.917 414.824 272.486 418.532 272.486 418.532C272.486 418.532 265.303 415.616 261.49 412.473C257.677 409.329 255.927 407.254 255.927 407.254C255.927 407.254 257.15 400.931 260.627 396.84C264.092 392.749 269.152 392.245 269.152 392.245Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.489 412.485C265.302 415.628 272.484 418.544 272.484 418.544C272.484 418.544 267.915 414.836 268.263 406.486C268.299 405.478 268.503 404.494 268.791 403.559C267.352 403.631 265.769 403.954 264.198 404.758C262.232 405.766 260.409 407.446 256.92 403.715C256.213 405.742 255.913 407.266 255.913 407.266C255.913 407.266 257.676 409.341 261.489 412.485Z",
    fill: "#EFEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M158.852 369.197C154.415 381.747 162.437 385.934 161.298 396.912C160.159 407.89 149.187 431.429 166.957 437.44C184.727 443.451 202.233 453.541 211.897 453.541H200.398H152.785C152.785 453.541 152.497 426.03 152.161 418.496C151.825 410.961 149.535 382.599 149.535 382.599C153.348 376.012 157.005 367.902 158.84 363.978C160.674 360.055 163.3 356.648 158.852 369.197Z",
    fill: "#16399D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.044 405.874C132.305 407.794 128.78 409.138 127.533 413.193C126.286 417.248 129.584 424.195 131.49 424.291C133.397 424.387 174.128 413.301 180.159 411.921C186.202 410.541 186.514 408.886 190.039 410.242C193.552 411.609 198.852 413.829 200.735 414.393C202.617 414.957 214.967 408.574 214.931 407.434C214.895 406.282 203.636 409.858 202.221 409.306C200.819 408.754 195.555 404.771 192.881 403.739C190.207 402.695 185.711 403.871 183.277 404.711C180.843 405.55 156.178 405.97 149.14 406.162C142.114 406.342 139.044 405.874 139.044 405.874Z",
    fill: "#E3AA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.78 404.099C190.915 402.371 192.857 401.303 194.464 401.483C196.07 401.663 201.97 402.083 202.857 402.635C203.744 403.187 199.44 403.931 197.737 403.775C196.046 403.631 194.704 405.37 194.704 405.37L188.78 404.099Z",
    fill: "#F1AFB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.526 421.963C141.526 421.963 136.43 422.443 135.243 415.784C134.068 409.126 139.044 405.874 139.044 405.874C137.917 405.754 137.305 405.37 137.005 404.866C134.667 405.694 131.586 406.93 127.869 408.742C122.161 411.525 118.624 417.908 120.327 424.183C128.276 426.33 141.526 421.963 141.526 421.963Z",
    fill: "#FFFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.619 329.473C174.619 329.473 172.005 330.493 168.888 331.525C169.595 336.864 172.569 340.127 175.027 342.659L178.48 345.634L186.19 338.22L174.619 329.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.761 329.473C197.761 329.473 200.375 330.493 203.493 331.525C202.785 336.864 199.812 340.127 197.353 342.659L193.9 345.634L186.19 338.22L197.761 329.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.816 445.178H56.7109V446.534H294.816V445.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.246 445.178H56.7109V446.534H153.246V445.178Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.075 445.178H56.7109V446.534H106.075V445.178Z",
    fill: "#B22441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2342 448.142H67.4062V451.645H68.2342V448.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8289 448.142H69.001V451.645H69.8289V448.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0041 449.893L72.8506 448.07V451.717L76.0041 449.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5888 448.144H61.0156V451.719H64.5888V448.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.512 458.748H56.7109V460.451H240.512V458.748Z",
    fill: "#89C6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.706 463.763H56.7109V465.466H112.706V463.763Z",
    fill: "#89C6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.706 467.506H56.7109V469.198H112.706V467.506Z",
    fill: "#89C6C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.182 271.573H370.753C372.911 271.573 374.65 273.324 374.65 275.472V324.854C374.65 327.014 372.899 328.753 370.753 328.753H271.196L264.362 335.592V328.753H264.182C262.024 328.753 260.285 327.002 260.285 324.854V275.472C260.285 273.324 262.024 271.573 264.182 271.573Z",
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.87 312.58C278.87 313.852 277.839 314.884 276.568 314.884C275.297 314.884 274.266 313.852 274.266 312.58C274.266 311.309 275.297 310.277 276.568 310.277C277.839 310.277 278.87 311.309 278.87 312.58Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.668 314.884C326.94 314.884 327.971 313.853 327.971 312.58C327.971 311.308 326.94 310.277 325.668 310.277C324.397 310.277 323.366 311.308 323.366 312.58C323.366 313.853 324.397 314.884 325.668 314.884Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.113 314.884C302.384 314.884 303.415 313.853 303.415 312.58C303.415 311.308 302.384 310.277 301.113 310.277C299.841 310.277 298.811 311.308 298.811 312.58C298.811 313.853 299.841 314.884 301.113 314.884Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.508 341.507H67.4072V361.603H101.508V341.507Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6908 351.549L82.3359 347.878V355.22L88.6908 351.549Z",
    fill: "#FE4F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.508 368.465H67.4072V388.561H101.508V368.465Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6908 378.519L82.3359 374.836V382.19L88.6908 378.519Z",
    fill: "#FE4F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.508 395.436H67.4072V415.532H101.508V395.436Z",
    fill: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6908 405.478L82.3359 401.807V409.161L88.6908 405.478Z",
    fill: "#FE4F60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13 210.037H-6.7168V280.247H120.13V210.037Z",
    fill: "#009AE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.112 214.272H-2.68848V276.012H116.112V214.272Z",
    fill: "#87CFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.958008 245.142L23.9916 233.372L40.0467 251.26L55.7901 237.007L70.0467 257.331L79.4352 253.084L87.6246 257.331L107.013 237.007L112.469 254.296V272.484H0.958008V245.142Z",
    fill: "#C7DBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9316 272.484V233.372",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.083 272.484V251.261",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.79 272.484V237.007",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0469 272.484V257.331",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.459 272.484V253.084",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7686 272.484V257.331",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.05 272.484V237.007",
    stroke: "#FCFCFC",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9308 234.716C24.6725 234.716 25.2737 234.114 25.2737 233.372C25.2737 232.63 24.6725 232.028 23.9308 232.028C23.1891 232.028 22.5879 232.63 22.5879 233.372C22.5879 234.114 23.1891 234.716 23.9308 234.716Z",
    fill: "#FBEB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1331 237.007C57.1331 237.751 56.5336 238.351 55.7902 238.351C55.0468 238.351 54.4473 237.751 54.4473 237.007C54.4473 236.264 55.0468 235.664 55.7902 235.664C56.5336 235.676 57.1331 236.276 57.1331 237.007Z",
    fill: "#FBEB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3899 257.331C71.3899 258.075 70.7904 258.675 70.047 258.675C69.3036 258.675 68.7041 258.075 68.7041 257.331C68.7041 256.587 69.3036 255.988 70.047 255.988C70.7904 255.988 71.3899 256.587 71.3899 257.331Z",
    fill: "#009AE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1116 257.331C89.1116 258.075 88.5121 258.675 87.7687 258.675C87.0253 258.675 86.4258 258.075 86.4258 257.331C86.4258 256.587 87.0253 255.988 87.7687 255.988C88.5121 255.988 89.1116 256.587 89.1116 257.331Z",
    fill: "#009AE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0832 252.604C40.8248 252.604 41.4261 252.003 41.4261 251.26C41.4261 250.518 40.8248 249.917 40.0832 249.917C39.3415 249.917 38.7402 250.518 38.7402 251.26C38.7402 252.003 39.3415 252.604 40.0832 252.604Z",
    fill: "#FBEB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1995 252.664C78.4273 251.969 79.1827 251.585 79.8902 251.813C80.5856 252.041 80.9693 252.796 80.7415 253.504C80.5137 254.2 79.7583 254.584 79.0508 254.356C78.3554 254.116 77.9717 253.36 78.1995 252.664Z",
    fill: "#FBEB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.779 236.587C106.006 235.892 106.762 235.508 107.469 235.736C108.165 235.964 108.548 236.719 108.321 237.427C108.093 238.123 107.337 238.507 106.63 238.279C105.934 238.051 105.551 237.295 105.779 236.587Z",
    fill: "#FBEB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.4346 364.94C-44.0557 364.94 -55.0869 353.89 -55.0869 340.273C-55.0869 326.667 -44.0797 315.641 -30.5066 315.605V301.124C-52.0893 301.16 -69.5713 318.677 -69.5713 340.285C-69.5713 361.916 -52.0533 379.445 -30.4346 379.445C-17.2212 379.445 -5.54258 372.882 1.54375 362.852L-10.2908 354.514C-14.7632 360.812 -22.1133 364.94 -30.4346 364.94Z",
    fill: "#0E5BC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.79731 312.545L-13.0371 322.791C-8.5527 327.254 -5.78293 333.444 -5.78293 340.271C-5.78293 345.574 -7.46158 350.481 -10.3033 354.5L1.53122 362.839C6.03961 356.456 8.68948 348.681 8.68948 340.271C8.70147 329.437 4.31299 319.635 -2.79731 312.545Z",
    fill: "#A4C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.235 210.169L175.357 203.954L171.832 208.441C170.297 207.781 168.714 207.337 167.096 207.109L166.424 201.446L156.46 202.634L157.132 208.297C155.621 208.909 154.182 209.713 152.839 210.708L148.355 207.181L142.144 215.064L146.628 218.591C145.969 220.127 145.525 221.71 145.297 223.33L139.638 224.002L140.825 233.972L146.484 233.3C147.096 234.812 147.899 236.251 148.894 237.595L145.369 242.082L153.247 248.297L156.772 243.81C158.307 244.47 159.889 244.914 161.508 245.142L162.18 250.805L172.144 249.617L171.472 243.954C172.983 243.342 174.422 242.538 175.765 241.542L180.249 245.07L186.46 237.187L181.976 233.66C182.635 232.124 183.079 230.541 183.307 228.921L188.966 228.249L187.779 218.279L182.12 218.951C181.508 217.439 180.705 215.999 179.71 214.656L183.235 210.169ZM173.894 233.684C169.722 238.987 162.036 239.899 156.736 235.724C151.436 231.548 150.525 223.858 154.698 218.555C158.87 213.252 166.556 212.34 171.856 216.515C177.156 220.69 178.079 228.369 173.894 233.684Z",
    fill: "#377CDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.081 205.837L213.354 200.535L210.345 201.518C209.841 200.738 209.242 200.043 208.57 199.443L210.009 196.623L205.033 194.092L203.594 196.911C202.707 196.719 201.796 196.659 200.872 196.707L199.889 193.696L194.589 195.424L195.573 198.435C194.793 198.939 194.098 199.539 193.498 200.211L190.681 198.771L188.151 203.75L190.968 205.19C190.776 206.077 190.717 206.989 190.764 207.913L187.755 208.897L189.482 214.2L192.491 213.216C192.995 213.996 193.594 214.692 194.266 215.292L192.827 218.111L197.803 220.643L199.242 217.823C200.129 218.015 201.04 218.075 201.964 218.027L202.947 221.038L208.247 219.311L207.263 216.299C208.043 215.796 208.738 215.196 209.338 214.524L212.155 215.963L214.685 210.984L211.868 209.545C212.059 208.657 212.119 207.745 212.071 206.821L215.081 205.837ZM203.51 213.816C199.949 214.98 196.112 213.024 194.949 209.461C193.786 205.897 195.74 202.058 199.302 200.894C202.863 199.731 206.7 201.686 207.863 205.25C209.026 208.825 207.083 212.652 203.51 213.816Z",
    fill: "#87CFF7",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.654 487.09V481.331H281.004V487.09H378.654Z",
    fill: "#EFC541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.655 513.402V507.643H281.005V513.402H378.655Z",
    fill: "#EFC541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.521 507.636V487.084H282.126V507.636H377.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M371.386 491.881V490.405H340.511V491.881H371.386Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M372.379 502.87V501.394H341.504V502.87H372.379Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M321.749 503.613V502.137H290.874V503.613H321.749Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M351.733 498.095V496.619H320.858V498.095H351.733Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M321.751 492.625V491.149H290.876V492.625H321.751Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.858 481.36H347.414V458.924H317.858V481.36Z",
    fill: "#D36AAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.055 477.328H328.359V462.955H324.055V477.328Z",
    fill: "#BA529B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.337 477.324V481.356H414.634V477.324H346.337Z",
    fill: "#BA589C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.335 458.921V462.953H414.632V458.921H346.335Z",
    fill: "#BA589C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.851 477.327V481.358H346.328V477.327H317.851Z",
    fill: "#E882C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.849 458.924V462.955H346.326V458.924H317.849Z",
    fill: "#E882C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.035 447.118V444.551H308.417V447.118H390.035Z",
    fill: "#0E5BC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.033 458.873V456.305H308.414V458.873H390.033Z",
    fill: "#0E5BC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.099 456.295V447.117H309.363V456.295H389.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M342.477 454.502V453.842H316.673V454.502H342.477Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M367.538 452.039V451.379H341.735V452.039H367.538Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M342.475 449.593V448.933H316.671V449.593H342.475Z",
    fill: "#D6D5D2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20.543 423.379L-15.0634 417.908L-9.59574 412.437L13.21 421.087L0.668051 433.648L-11.8859 446.198L-20.543 423.379Z",
    fill: "#234054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.9983 446.198L13.2103 421.975C13.4501 421.735 13.4501 421.327 13.2103 421.087C12.9705 420.847 12.5629 420.847 12.323 421.087L-11.8856 445.31C-12.1254 445.55 -12.1254 445.958 -11.8856 446.198C-11.6338 446.45 -11.2381 446.45 -10.9983 446.198Z",
    fill: "#CCCCCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M13.2115 421.087L274.254 514.033H20.0221L-10.9971 446.198L13.2115 421.087Z",
    fill: "#E6F5FD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.662 226.559C303.183 217.146 296.79 208.284 287.382 206.764C277.975 205.244 269.116 211.643 267.595 221.055C266.074 230.468 272.467 239.331 281.874 240.85C291.282 242.37 300.141 235.972 301.662 226.559Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.613 241.075C291.487 241.075 297.059 233.345 297.059 223.81C297.059 214.275 291.487 206.545 284.613 206.545C277.739 206.545 272.167 214.275 272.167 223.81C272.167 233.345 277.739 241.075 284.613 241.075Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.613 241.075C287.592 241.075 290.008 233.345 290.008 223.81C290.008 214.275 287.592 206.545 284.613 206.545C281.633 206.545 279.217 214.275 279.217 223.81C279.217 233.345 281.633 241.075 284.613 241.075Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.614 236.264C294.143 236.264 301.868 230.688 301.868 223.81C301.868 216.932 294.143 211.357 284.614 211.357C275.084 211.357 267.359 216.932 267.359 223.81C267.359 230.688 275.084 236.264 284.614 236.264Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.614 229.209C275.081 229.209 267.359 226.785 267.359 223.81C267.359 220.823 275.081 218.411 284.614 218.411C294.146 218.411 301.868 220.835 301.868 223.81C301.868 226.785 294.134 229.209 284.614 229.209Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.111 174.032V185.274",
    stroke: "white",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.735 179.659H110.488",
    stroke: "white",
    strokeWidth: 0.429766,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7918,
    cy: 114.318,
    rx: 29.203,
    ry: 29.2241,
    fill: "#FFE4DC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8236 109.157L42.7686 114.2L49.8236 119.243V109.157Z",
    fill: "#F15123",
    stroke: "#F15123",
    strokeWidth: 2.01718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7526 107.14H29.6661C28.5529 107.14 27.6504 108.043 27.6504 109.157V119.243C27.6504 120.357 28.5529 121.26 29.6661 121.26H40.7526C41.8659 121.26 42.7683 120.357 42.7683 119.243V109.157C42.7683 108.043 41.8659 107.14 40.7526 107.14Z",
    fill: "#F15123",
    stroke: "#F15123",
    strokeWidth: 2.01718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.01,
    cy: 69.6222,
    rx: 25.7673,
    ry: 25.786,
    fill: "#E3F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.875 65.7897L217.412 76.9095H200.338L208.875 65.7897Z",
    fill: "#657382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.508 70.0257L225.171 76.9093H213.801L219.508 70.0257Z",
    fill: "#657382"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.955,
    cy: 60.2296,
    rx: 3.8911,
    ry: 3.97136,
    fill: "#637181"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.331,
    cy: 35.6706,
    rx: 24.479,
    ry: 24.4967,
    fill: "#EDF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.595 41.582H299.34L295.134 29.4697H292.154L287.949 41.582H290.492L291.424 38.6945H295.68L296.595 41.582ZM293.489 31.9878H293.64L295.143 36.7388H291.97L293.489 31.9878ZM306.474 37.7628H309.941V35.5972H306.474V32.1725H304.334V35.5972H300.876V37.7628H304.334V41.1959H306.474V37.7628Z",
    fill: "#009AE0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 514,
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 42,
    r: 27,
    fill: "#D8FFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 34L120.881 41.9206L109 49.8412V34Z",
    fill: "#6FCF97",
    stroke: "#6FCF97",
    strokeWidth: 3.53898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 313.181,
    y1: 253.806,
    x2: 330.671,
    y2: 304.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#79C7CD",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 332.65,
    y1: 242.217,
    x2: 354.652,
    y2: 306.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#79C7CD",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.00000111978,
    y1: 265.746,
    x2: 89.8112,
    y2: 271.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FAFC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 514,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1887,
    height: 24.2062,
    fill: "white",
    transform: "translate(26.6426 102.097)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegimg);
export default __webpack_public_path__ + "static/media/regimg.c7f28a5d1f8993abafaae36f2e99f86f.svg";
export { ForwardRef as ReactComponent };